// components/EmployeeAvatar.jsx
import { useState, useEffect } from "react";
import { Avatar, Skeleton } from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { getFotoEmpleado } from "../../RRHH2/features/legajos/services/empleados.api";

export default function EmployeeAvatar({
  cuil,
  nombre = "",
  apellido = "",
  size = 38,
  sx = {},
  ...props
}) {
  const [file, setFile] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cargar archivo del empleado
  useEffect(() => {
    const getFile = async () => {
      if (!cuil) {
        setLoading(false);
        return;
      }

      try {
        const data = await getFotoEmpleado(cuil);
        setFile(data);
      } catch (error) {
        console.error("Error al cargar foto:", error);
        setFile(null);
      } finally {
        setLoading(false);
      }
    };

    getFile();
  }, [cuil]);

  // Cargar imagen cuando cambia el archivo
  useEffect(() => {
    const fetchImage = async () => {
      if (!file || !file[0]) {
        setImageSrc(null);
        return;
      }

      const archivo = file[0];

      // Verificar que archivo existe y tiene las propiedades necesarias
      if (!archivo.id_archivo || !archivo.nombre) {
        setImageSrc(null);
        return;
      }

      try {
        const response = await fetch(
          `${UrlApi}/uploadfiles/uploads/${archivo.id_archivo}-${archivo.nombre}`
        );

        if (!response.ok) {
          throw new Error("Error al cargar la imagen");
        }

        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
      } catch (error) {
        console.error("Error al cargar imagen:", error);
        setImageSrc(null);
      }
    };

    fetchImage();

    // Cleanup: liberar la URL del objeto cuando el componente se desmonte
    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [file]);

  if (loading) {
    return <Skeleton variant="circular" width={size} height={size} />;
  }

  const initials = `${nombre?.[0] || ""}${apellido?.[0] || ""}`;

  return (
    <Avatar
      src={imageSrc}
      sx={{
        bgcolor: imageSrc ? "transparent" : "primary.light",
        width: size,
        height: size,
        fontSize: size * 0.4,
        fontWeight: "bold",
        ...sx,
      }}
      {...props}
    >
      {!imageSrc && initials}
    </Avatar>
  );
}
